import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/components/layout'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/components/layout'], resolve),
      meta: {
        title: '登录'
      },
      children: [
        {
          path: '/login',
          name: 'login',
          component: resolve => require(['@/view/login'], resolve),
          meta: {
            title: '登录'
          }
        }
      ]
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/view/register'], resolve),
      meta: {
        title: '注册'
      }
    },
    {
      path: '/user/index',
      name: 'user-index',
      component: resolve => require(['@/view/user/index'], resolve),
      meta: {
        title: '用户中心'
      }
    },
    {
      path: '/user/vip',
      name: 'user-vip',
      component: resolve => require(['@/view/user/vip'], resolve),
      meta: {
        title: '搭桥会员'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js